import BeelditSwitchInput from "@beeldit/core/components/BeelditSwitchInput";
import { RowAction } from "@beeldit/core/enums/RowAction.enum";
import { TableAction } from "@beeldit/core/enums/TableAction.enum";
import CustomerTreatmentSelector from "@main/customers-treatments/components/CustomerTreatmentSelector";
import { CustomerTreatment } from "@main/customers-treatments/models/CustomerTreatment";
import { Pencil, Plus, Trash, HandCoins } from "@phosphor-icons/react";
import { t } from "i18next";
import { min } from "lodash";

const config = {
  modelName: "debt",
  modelPluralName: "debts",
  endpoint: "debts",
  indexQueryParams: {
    relations: ['customerTreatment', 'customerTreatment.treatment'],
  },
  // Default ordering: date descending
  tableConfig: {
    defaultOrderBy: "-date",
    index: null,
    actions: [
  
      {
        name: TableAction.CREATE,
        label: "create",
        showLabel: true,
        allowed: true,
        show: true,
        action: null,
        icon: <Plus size={20} />,
      },
    ],
    rowActions: [
      {
        name: RowAction.EDIT,
        label: "edit",
        icon: <Pencil size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("edit", element);
        },
      },
      {
        name: "create-charge",
        label: "add_charge",
        icon: <HandCoins size={20} />,
        allowed: true,
        show: (element: any) => {
          // Mostrar solo si queda deuda por pagar
          return (element.toPay ?? 0) > 0;
        },
        action: null,
        data: "id",
      },
      {
        name: RowAction.DELETE,
        label: "delete",
        icon: <Trash size={20} />,
        allowed: true,
        show: true,
        action: (element: any) => {
          console.log("delete", element);
        },
      },
    ],
    rowConfiguration: {
      class: (element: any) => {
        return null;
      },
    },
    columns: [
      {
        name: "id",
        label: "#",
        key: "id",
        type: "number",
        show: true,
        allowOrder: true,
      },
      {
        name: "date",
        label: "date",
        key: "date",
        type: "date",
        show: true,
        allowOrder: true,
      },
      {
        name: "amount",
        label: "amount",
        key: "amount",
        type: "currency",
        currency: "EUR",
        show: true,
        allowOrder: true,
      },
      {
        name: "to_pay",
        label: "to_pay",
        key: "toPay",
        type: "currency",
        currency: "EUR",
        show: true,
        allowOrder: true,
      },
      {
        name: "customer_treatment_name",
        label: t("customer_treatment"),
        key: "customer_treatment.treatment.name",
        type: "string",
        show: true,
        allowOrder: true,
      }
    ],
    pagination: {
      enabled: true,
      back: true,
    },
  },
  filterConfig: {
    type: "object",
    properties: {
      search: {
        type: "string",
      },
    },
  },
  filterUIConfig: {
    uiScheme: {
      className: "filters-container",
      search: {
        "ui:options": {
          label: false, // Oculta el título del campo
          placeholder: "Buscar...",
        },
      },
    },
    widgets: {},
  },
  formSchema: {
    type: "object",
    properties: {            
      customer_treatment_id: {
        type: ["number", "null"],
        title: t("customer_treatment_id"),
      },
      amount: {
        type: "number",
        title: t("amount"),
        minimum: 0,
        default: 0,
      },
      date: {
        type: "string",
        title: t("date"),
        format: "date",
      },
      comments: {
        type: ["string", "null"],
        title: t("comments"),
        format: "textarea",
      }
    },
  },
  uiFormSchema: {
    "ui:submitButtonOptions": {
      props: {
        disabled: false,
        className: "btn btn-info",
      },
      norender: true,
    },
    customer_treatment_id: {
      "ui:widget": CustomerTreatmentSelector,      
    },
    colsSchema: [
      {
        cols: "col-12",
        elements: [
          [
            {
              name: "customer_treatment_id",
              cols: "col-12",
            },
            {
              name: "amount",
              cols: "col-6",
            },
            {
              name: "date",
              cols: "col-6",
            },
            {
              name: "comments",
              cols: "col-12",
              "ui:widget": "textarea",
            }
          ],
        ],
      },
    ],
  },
};
export default config;
